export default __webpack_public_path__ + "static/research-offer-4f22dc51449ec6cf0ee65abcc9d1cace.png";